import React from 'react';
export function SiteFooter() {
  return <footer className="bg-ink py-10 text-cream/70" data-id="element-207" data-mp="348oflv2iyool">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-5 text-center text-sm md:flex-row md:justify-between md:text-left" data-id="element-208" data-mp="1t6dkf15wctpl">
        <p data-id="element-209" data-mp="1o82c4uv92r9h">
          © 2026 Sesiones Listas™. Todos los derechos reservados.
        </p>
        <nav aria-label="Legal" className="flex gap-6" data-id="element-210" data-mp="1jaals5a97d7e">
          <a href="#" className="transition-colors duration-150 hover:text-cream" data-id="element-211" data-mp="2gwzu0wvjum1p">Términos</a>
          <a href="#" className="transition-colors duration-150 hover:text-cream" data-id="element-212" data-mp="2bxmx1jayryle">Privacidad</a>
          <a href="#" className="transition-colors duration-150 hover:text-cream" data-id="element-213" data-mp="26y0jf8r84gc2">Reembolsos</a>
        </nav>
      </div>
    </footer>;
}